import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import HttpApi from 'i18next-http-backend'
import LanguageDetector from 'i18next-browser-languagedetector'

const stripRegionalPart = (lng) => lng.split('-')[0].toLowerCase()

const getFallbackLng = (lng) => {
  const strippedLng = stripRegionalPart(lng)
  if (['ca', 'an', 'gl', 'val', 'es'].includes(strippedLng)) {
    return 'es'
  }
  return 'en'
}

// Custom language detector
const languageDetector = new LanguageDetector()
languageDetector.init({
  convertLanguageByDefault: true,
  convertLowerCaseByDefault: true,
  lookupLocalStorage: 'i18nextLng',
  order: ['navigator', 'localStorage'],
  caches: ['localStorage'],

  // Add converter function
  convertDetectedLanguage: (lng) => stripRegionalPart(lng),

  detection: {
    cacheUserLanguage: function (lng) {
      const strippedLng = stripRegionalPart(lng)
      const finalLng = strippedLng === 'es' ? 'es' : strippedLng
      localStorage.setItem('i18nextLng', finalLng)
    },
  },
})

i18n
  .use(HttpApi)
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: getFallbackLng,
    // debug: true,
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: '/locales/{{lng}}.json',
    },
    load: 'languageOnly',
    cleanCode: true,
    lowerCaseLng: true,
    detection: {
      order: ['localStorage', 'navigator'],
      convertDetectedLanguage: (lng) => stripRegionalPart(lng),
    },
  })

export default i18n
